import debounce from 'lodash/debounce'
import {
  InsertionOrdersModel,
  UpdateInsertionOrdersForm,
} from '@/models/InsertionOrders'
import { AgencyMarginModel } from '@/models/AgencyMargin'
import { AdvertiserModel } from '@/models/Advertiser'
import { getters as currentAdvertiserGetter } from '@/vuex/modules/currentAdvertiser/constants'

const actions = {
  async INIT_SEARCH_ITEMS({ commit }, advertiserId) {
    commit('SET_ADVERTISER_ID', advertiserId)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_KEYWORD({ commit }, keyword) {
    commit('SET_KEYWORD', keyword)
    commit('SET_PAGE_NO', 1)
  },

  async SET_SEARCH_PAGE_NO({ commit }, pageNo) {
    commit('SET_PAGE_NO', pageNo)
  },

  async SET_SEARCH_STATUSES({ commit }, ioStatuses) {
    commit('SET_STATUSES', ioStatuses)
  },

  UPDATE_SORT_OPTIONS({ commit }, { sortBy, descending }) {
    commit('UPDATE_SORT_OPTIONS', { sortBy, descending })
  },

  SET_INSERTION_ORDERS: debounce(async ({ state, commit, rootGetters }) => {
    commit('SET_LOADING', 'search')
    const keyword = state.keyword
    const advertiserId =
      rootGetters[currentAdvertiserGetter.currentAdvertiser].id
    const pageNo = state.pageNo
    const pageSize = state.pageSize
    const ioStatuses = state.ioStatuses
    const sortKey = state.sortOptions.sortBy
    const sortDirection = state.sortOptions.descending ? 'desc' : 'asc'
    const params = {
      advertiserId,
      keyword,
      pageNo,
      pageSize,
      ioStatuses,
      sortKey,
      sortDirection,
    }
    let ret = await InsertionOrdersModel.search(params)
    commit('SET_SEARCH_RESULT', ret)
    commit('CLEAR_LOADING', 'search')
  }, 300),

  SET_LOADING({ commit }, key) {
    commit('SET_LOADING', key)
  },

  CLEAR_LOADING({ commit }, key) {
    commit('CLEAR_LOADING', key)
  },

  async SET_IO_STATUS({ commit }, { insertionOrder, status }) {
    const form = new UpdateInsertionOrdersForm(insertionOrder)
    form.status = status
    try {
      const updatedInsertionOrder = await form.save()
      commit('UPDATE_IO', { insertionOrder: updatedInsertionOrder })
    } catch (e) {
      console.error(e)
      throw e
    }
  },

  CHANGE_IO({ commit }, { insertionOrder }) {
    commit('UPDATE_IO', { insertionOrder })
  },

  async DELETE_IO({ commit }, { insertionOrder }) {
    await insertionOrder.destroy()
    commit('DELETE_IO', { insertionOrder })
  },

  async GET_AGENCY_MARGIN_LIST({ commit }, agencyId) {
    commit('SET_LOADING', 'agencyMarginList')
    const result = await AgencyMarginModel.search({
      agencyId: agencyId,
      requestStatus: ['approved'],
    })
    commit('SET_AGENCY_MARGIN_LIST', result.items)
    commit('CLEAR_LOADING', 'agencyMarginList')
  },

  async GET_SALES_ACCOUNT_LIST({ commit }, advertiserId) {
    commit('SET_LOADING', 'salesAccountList')
    const advertiser = new AdvertiserModel({ id: advertiserId })
    const accountList = await advertiser.getAccountList()
    commit('SET_SALES_ACCOUNT_LIST', accountList)
    commit('CLEAR_LOADING', 'salesAccountList')
  },
}

export default actions
